// extracted by mini-css-extract-plugin
module.exports = {"DecodedMsgBox":"DecodedMsgBox_DecodedMsgBox__3TdSy"};